import {
    SmallTextHelper,
    UrlHelper

} from '../PrismicHelpers';

export const eventListHelper = (response) => {

    const eventData = response.result;

    let eventObject = eventData.map(event => {
        return {
            uid: SmallTextHelper(event.id),
            date: SmallTextHelper(event.data.date),
            image: UrlHelper(event.data.image),
            name: SmallTextHelper(event.data.title[0].text),
            url: SmallTextHelper(event.data.url_eventbrite.url),
            description: SmallTextHelper(event.data.description[0].text),
            city: SmallTextHelper(event.data.city[0].text),
            country: SmallTextHelper(event.data.country)
        }
    })
    return eventObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/EventHelpers.js